function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "m8.4 10.281v2.465a.7.7 0 0 0 .7.7h4.2a.7.7 0 0 0 .7-.7v-6.188a1.12 1.12 0 0 0 -.328-.792l-5.881-4.88a1.118 1.118 0 0 0 -1.582 0l-5.881 4.88a1.12 1.12 0 0 0 -.328.792v6.188a.7.7 0 0 0 .7.7h4.2a.7.7 0 0 0 .7-.7v-2.465a1.4 1.4 0 0 1 1.4-1.4 1.4 1.4 0 0 1 1.4 1.4z",
  fill: "currentColor"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 14 14"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/home-filled.1611faf6.svg";
export { SvgComponent as ReactComponent };